import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {WorkflowBasic} from "@shared-interfaces/shared-workflow";
import {MatButtonModule} from "@angular/material/button";
import {MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'contract-name-dialog',
  standalone: true,
  imports: [MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    TranslateModule
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        subscriptSizing: 'dynamic',
        appearance: 'outline'
      }
    }
  ],
  templateUrl: './contract-name-dialog.component.html',
  styleUrl: './contract-name-dialog.component.scss'
})
export class ContractNameDialogComponent {
  constructor(
      public dialogRef: MatDialogRef<ContractNameDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: WorkflowBasic
  ) { }

  public onSave(): void {
    this.dialogRef.close();
  }
}
